import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import SingleOrder from "../components/orderHistory/SingleOrder";
import ProductInfo from "../components/infoScreens/ProductInfo";

export default function ProductInfoView() {
  return (
    <div className="pageWrapper">
      <Header title="Over het Product" />
      <div className="contentWrapper fadeInDelayed">
        <ProductInfo />
      </div>
      <BottomNavBar />
    </div>
  );
}
